module.exports = __webpack_public_path__ + "static/media/city-elements-facilities-svgrepo-com.46f98223.svg";